<template>
  <v-dialog
    persistent
    v-model="show"
    max-width="430"
    content-class="popup-wrap-1"
  >
    <div class="pa-8">
      <h3 class="title-type-4 mb-2">{{ propsItem.name }}</h3>
      <p class="form-coment-1 mt-3">
        <v-icon>mdi-alert-circle-outline</v-icon>
        해당 지면의 상품 지면 메모 입니다.
      </p>
      <div class="text-type-1">
        {{ propsItem.note }}
      </div>
      <div class="d-flex justify-center mt-8">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click="confirm"
        >
          확인
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    propsItem: Object,
  },
  data: () => ({}),
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    confirm() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.previewImage {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 360px;
    max-height: 640px;
  }
}
</style>
